(function () {
  "use strict";

  /* ---------------------------------------------------------
     1. CONFIG
     Same engine and look as the Custom Shop form. No pricing
     of any kind lives in this file: option names only.
     --------------------------------------------------------- */
  var _el = document.getElementById("tmePE");
  var _d = (_el && _el.dataset) || {};
  var CONFIG = {
    // Set in the theme editor, not here.
    endpoint: _d.endpoint || "",
    email: _d.email || "electrics@themusicemporium.com",
    formName: _d.formname || "Powers Electric Build Request",
    imageBase: _d.imagebase || "https://powerselectricguitars.com/cdn/shop/files/",
    brand: "Powers Electric"
  };

  var ASK = "No preference, let's discuss";

  /* ---------------------------------------------------------
     2. OPTION DATA
        Colors and finish levels from the Powers Electric
        Jan 8 2026 dealer price list (MATRIX and Two-Tone tabs).
        Pickups and tailpiece from Powers Electric's public
        A-Type spec. Review whenever Powers reissues the list.
     --------------------------------------------------------- */
  function o(label, blurb) { return { label: label, blurb: blurb }; }
  function list(arr) { return arr.map(function (n) { return o(n); }); }

  var PREMIUM = ["Alaska Blue Metallic", "Amethyst Pearl Metallic", "Artesian Turquoise", "Aubergine", "Auratium Green", "Bahama Blue", "Battleship Gray", "Bitter Chocolate", "Black Olive", "British Racing Green Metallic", "Buttercream Yellow", "Byzantine Gold", "CadZZilla Purple", "California Coral", "Casablanca Beige Metallic", "Cascade Blue", "Chalk", "Cherry Bomb", "Cochon Pink", "Continental Orange", "Coppa Florio Blue", "Copper Metallic", "Copper Ruby Metallic", "Cranberry Metallic", "Crayon Gray", "Creamsicle", "Cruise Night Blue", "Crystal Red Metallic", "Dark British Racing Green Metallic", "Dark Turquoise Metallic", "Deep Impact Blue", "Dolomite Silver", "Fayence Yellow", "Fern Green", "Fjord Green", "Frozen Berry Metallic", "Garnet Red", "Geranium Red", "Gold Metallic", "Golden Yellow Metallic", "Graphite Metallic", "Grey Black", "Guards Red", "Hemi Orange", "Iceland Silver", "Imperial Bronze", "Ipanema Blue Metallic", "Java Green Metallic", "Jet Black", "Kingfisher Blue", "Lapis Blue", "Larkspur Blue", "Leaf Green", "Lido Gold", "Light Turquoise", "Liquid Metal Chrome Blue", "Lizard Green", "London Grey", "Magenta", "Maui Blue", "Meissen Blue", "Midnight Blue", "Mint Green", "Moonlight White", "Murano Green", "Nordic Gold Metallic", "Onyx Green Metallic", "Orange", "Orange Pearl", "Oslo Blue", "Palm Green", "Pastel Beige", "Pastel Yellow", "Pearl White", "Platinum Metallic", "Polar Silver Metallic", "Reflect Red", "Ruby Star", "Saffron Yellow Metallic", "Sage Green Metallic", "Salmon Metallic", "Sandalwood Tan", "Satin Black", "Seneca Blue", "Shark Blue", "Sienna Metallic", "Signal Red", "Signal Yellow", "Silver Blue Metallic", "Silver Jade Mach 1", "Soul Red Crystal", "Summer Yellow", "Terra Cotta", "Tourmaline Green Metallic", "Tropical Turquoise", "Turquoise Metallic", "Valencia Orange", "Velvet Purple Metallic", "Viola Purple Metallic", "Willow Green"];
  var SHIFTS = ["Chroma Watermelon", "Chroma Plum", "Chroma Vega", "Chroma Geo Midas", "Chroma Thundercloud Pearl", "Chroma Arson", "Chroma Supernova"];
  var GHOST = ["Cruise Night Blue Ghost Flame", "Saffron Yellow Metallic Ghost Flame", "Sage Green Metallic Ghost Flame", "Signal Red Ghost Flame", "Sandalwood Tan Ghost Flame"];
  var SELECT_PREMIUM = ["Blue Lagoon", "Cosmo Orange", "Cosmo Red", "Cabernet Red", "Desert Dawn", "Juniper Green", "Pale Ale", "Shadow Black", "Solana Sunset", "Sweet Tea Orange", "Twilight Blue", "Wild Honey Burst", "Chroma Silver Cranberry"];
  var TWO_TONE_FAMILIES = {"Unbased": ["Aubergine", "Auratium Green", "Bitter Chocolate", "Black Olive", "California Coral", "Fjord Green", "Frozen Berry Metallic", "Golden Yellow Metallic", "Ipanema Blue Metallic", "Midnight Blue", "Larkspur Blue", "Magenta", "Maui Blue", "Meissen Blue", "Murano Green", "Oslo Blue", "Palm Green", "Ruby Star", "Seneca Blue", "Signal Red"], "Black": ["Amethyst Pearl Metallic", "Artesian Turquoise", "Battleship Gray", "Jet Black", "British Racing Green Metallic", "Byzantine Gold", "CadZZilla Purple", "Cranberry Metallic", "Casablanca Beige Metallic", "Chalk", "Copper Metallic", "Copper Ruby Metallic", "Dark British Racing Green Metallic", "Dark Turquoise Metallic", "Deep Impact Blue", "Dolomite Silver", "Gold Metallic", "Grey Black", "Iceland Silver", "Liquid Metal Chrome Blue", "London Grey", "Nordic Gold Metallic", "Onyx Green Metallic", "Platinum Metallic", "Polar Silver Metallic", "Imperial Bronze", "Sage Green Metallic", "Sandalwood Tan", "Silver Jade Mach 1", "Velvet Purple Metallic"], "White": ["Pearl White", "Bahama Blue", "Cherry Bomb", "Crayon Gray", "Fern Green", "Geranium Red", "Guards Red", "Lido Gold", "Lizard Green", "Pastel Beige", "Cochon Pink", "Salmon Metallic", "Shark Blue", "Silver Blue Metallic", "Tropical Turquoise", "Tourmaline Green Metallic", "Viola Purple Metallic"], "Orange": ["Continental Orange", "Creamsicle", "Hemi Orange", "Orange Pearl", "Valencia Orange"], "Blue": ["Alaska Blue Metallic", "Cascade Blue", "Coppa Florio Blue", "Cruise Night Blue", "Kingfisher Blue", "Lapis Blue"], "Yellow": ["Fayence Yellow", "Pastel Yellow", "Saffron Yellow Metallic", "Signal Yellow", "Summer Yellow", "Buttercream Yellow"], "Red": ["Garnet Red", "Sienna Metallic", "Terra Cotta"], "Green": ["Java Green Metallic", "Willow Green"]};

  /* Photos of each finish, taken from the Powers Electric site and
     grouped the way they group them there. Key is the color name as
     Powers writes it; value is the image file. PREVIEW ONLY: these
     load from Powers' own CDN. Swap CONFIG.imageBase for our own
     Shopify Files URL once we host the images. */
  var COLOR_LIBRARY = {
"Special Burst": {
"Glacier Burst": "PowersElectric-Transparent-GlacierBurst_db96cf4a-cfe3-4c90-91cc-349d000b1b16.png?v=1770935051",
"Lava Burst": "PowersElectric-Transparent-LavaBurst_6514738f-3c66-4f20-9504-e8dd7eb3b404.png?v=1770935062"
},
"Color Shift": {
"Chroma Algae": "PowersElectric-Transparent-ChromaAlgae.png?v=1743100447",
"Chroma Borealis": "Hero_-Taylor-Powers-Electric-Chroma-Borealis.png?v=1771956768",
"Chroma Chameleon": "Hero-Taylor-Powers-Electric-Chroma-Chamleon.png?v=1771957433",
"Chroma Cosmos": "Hero-Chroma-Cosmos.png?v=1771959556",
"Chroma Silver Cranberry": "Hero-Taylor-Powers-Electric-Chroma-Silver-Cranbery.png?v=1771960024",
"Chroma Stratus": "Hero-Taylor-Powers-Electric-Chroma-Stratus.png?v=1771966904",
"Chroma Watermelon": "Hero-Taylor-Powers-Electric-Chroma-Watermelon.png?v=1771967497"
},
"Green": {
"Fjord Green": "POWERSELECTRIC-FRONT-05192023-A010-FJORDGREEN-TRANSPARENT.webp?v=1719250969",
"Mint Green": "POWERSELECTRIC-FRONT-061423-A044-MINTGREEN-0342.webp?v=1719250969",
"Sage Green Metallic": "POWERSELECTRIC-FRONT-072523-A087-Sage-Green-Metallic-TRANSPARENT.webp?v=1719250969",
"Silver Jade Mach 1": "PowersElectric-FRONT-071823-A088-SILVERJADEMACH1-TRANSPARENT.webp?v=1719250969",
"Dark Turquoise Metallic": "POWERSELECTRIC-FRONT-A149_-_Dark_Turquoise_Metallic_-_Transparent.webp?v=1716485763",
"Dark British Racing Green Metallic": "POWERSELECTRIC-FRONT-A148_-_Dark_British_Racing_Green_Metallic_-_Transparent.webp?v=1716485990",
"Fern Green": "POWERSELECTRIC-FRONT-A220_-_Fern_Green_-_Transparent.webp?v=1716486223",
"Black Olive": "POWERSELECTRIC-FRONT-A362_-_Black_Olive_-_Transparent.webp?v=1716486568",
"Auratium Green": "POWERSELECTRIC-FRONT-A363_-_Auratium_Green_-_Transparent.webp?v=1716486728",
"Onyx Green Metallic": "POWERSELECTRIC-FRONT-A394_-_Onyx_Green_Metallic_-_Transparent.webp?v=1716487199",
"Tourmaline Green Metallic": "PowersElectric-Transparent-A439-TourmalineGreenMetallicTourmalineGreenMetallic.png?v=1719250578",
"Willow Green": "PowersElectric-Transparent-WillowGreen.png?v=1743028943",
"Juniper Green Quilted": "Hero-Taylor-Powers-Electric-Juniper-Green-Quilted.png?v=1771968510",
"Sage Green Metallic Ghost Flame": "Hero-Taylor-Powers-Electric-Sage-Green-Metallic-Ghost-Flame.png?v=1771969332"
},
"Blue": {
"Maui Blue": "PowersElectric_-TRANSPARENT-A246-Maui_B_1ae86b47-69fd-4613-b26f-465d067c4f68.webp?v=1716497896",
"Blue Lagoon": "POWERSELECTRIC-FRONT-05192023-A003-BLUELAGOON-TRANSPARENT.webp?v=1714165723",
"Meissen Blue": "POWERSELECTRIC-FRONT-05192023-A005-MEISSENBLUE-TRANSPARENT.webp?v=1714165723",
"Bahama Blue": "PowersElectric-FRONT-080123-A067-BahamaBlue-8329.webp?v=1714165723",
"Cascade Blue": "PowersElectric-FRONT-071823-A091-CASCADEBLUE-7807.webp?v=1714165723",
"Deep Impact Blue": "POWERSELECTRIC-FRONT-061423-A029-DEEPIMPACTBLUE-0336.webp?v=1714165723",
"Larkspur Blue": "POWERSELECTRIC-FRONT-062023-A046-Larkspur-Blue-0547.webp?v=1714165723",
"Midnight Blue": "POWERSELECTRIC-FRONT-062823-A054-Midnight-Blue-7567.webp?v=1714165723",
"Twilight Blue": "POWERSELECTRIC-FRONT-061423-A033-TWILIGHTBLUE-0348.webp?v=1714165723",
"Oslo Blue": "POWERSELECTRIC-FRONT-06022023-A024-OSLOBLUE-TRANSPARENT_1b78f750-d10a-4278-b594-270f320a3e53.webp?v=1714165723",
"Tropical Turquoise": "POWERSELECTRIC-FRONT-05192023-A013-TROPICALTURQUOISE-TRANSPARENT.webp?v=1714165723",
"Cruise Night Blue": "POWERSELECTRIC-FRONT-A215_-_Cruise_Night_Blue_-_Transparent.webp?v=1715722058",
"Alaska Blue Metallic": "POWERSELECTRIC-FRONT-A329_-_Alaska_Blue_Metallic_-_Transparent.webp?v=1715722502",
"Turquoise Metallic": "PowersElectric-TRANSPARENT-A180-Turquoise_Metallic_36317d08-4760-498d-a97e-27bbe49bcceb.webp?v=1716497845",
"Seneca Blue": "PowersElectric-TRANSPARENT-A224-Seneca_Blue_a4aa4b4c-545a-4ef3-94c8-5d05773d1470.webp?v=1716497763",
"Kingfisher Blue": "PowersElectric-TRANSPARENT-A261-Kingfisher_Blue.webp?v=1716497743",
"Lapis Blue": "PowersElectric-TRANSAPRENT-A374-Lapis_Blue.webp?v=1716497912",
"Silver Blue Metallic": "PowersElectric-TRANSPARENT-A403_-__Silver_Blue_Metallic.webp?v=1716497926",
"Shark Blue": "PowersElectric-Transparent-A443-SharkBlue_c54dd4fa-3994-4972-8b47-cbbeeccdfd5a.webp?v=1719249219",
"Aged Pelham Blue": "Aged-Pelham-Blue-Front_b2f8a5b0-d7b6-4aed-8290-b1283e0732f9.png?v=1770751520",
"Pelham Blue": "Hero-Taylor-Powers-Electric-Pelham-Blue.png?v=1771969096",
"Yachting Blue Metallic": "Hero-Taylor-Powers-Electric-Yachting-Blue-Metallic.png?v=1771971068"
},
"Red": {
"Signal Red": "POWERSELECTRIC-FRONT-062823-A059-SignalRed-8323.webp?v=1715717355",
"Cabernet Red": "POWERSELECTRIC-FRONT-06022023-A026-CABERNETRED-TRANSPARENT.webp?v=1715717355",
"Cosmo Red": "POWERSELECTRIC-FRONT-06022023-A021-COSMORED-TRANSPARENT.webp?v=1715717355",
"Garnet Red": "POWERSELECTRIC-FRONT-05192023-A007-GARNETRED-TRANSPARENT.webp?v=1715717355",
"Crystal Red Metallic": "POWERSELECTRIC-FRONT-061423-A051-CRYSTALREDMETALLIC-0359.webp?v=1715717355",
"Sienna Metallic": "POWERSELECTRIC-FRONT-05192023-A011-SIENNAMETALLIC-TRANSPARENT.webp?v=1715717355",
"Soul Red Crystal": "PowersElectric-FRONT-071823-A057-SOUL-RED-CRYSTAL-TRANSPARENT.webp?v=1715717355",
"Cranberry Metallic": "POWERSELECTRIC-FRONT-06022023-A019-CRANBERRYMETALLIC-TRANSPARENT.webp?v=1715717355",
"Cherry Bomb": "POWERSELECTRIC-FRONT-A222_-_Cherry_Bomb_-_Transparent_aac4acf2-aeb2-4eeb-b895-cb7413a341e8.webp?v=1715717140",
"Geranium Red": "POWERSELECTRIC-FRONT-A226_-_Geranium_Red_-_Transparent_2f115d0f-409c-4ec6-95ca-c5933974d068.webp?v=1715717587",
"Guards Red": "PowersElectric-Transparent-GuardsRed.png?v=1743027400",
"Signal Red Ghost Flame": "Hero-Taylor-Powers-Electric-Signal-Red-Ghost-Flame.png?v=1771969619"
},
"Brown and Bronze": {
"Imperial Bronze": "ImperialBronze-A102-FrontTRANSPARENT.webp?v=1716500322",
"Sandalwood Tan": "SandalwoodTan-A112-FrontTRANSPARENT.webp?v=1716500335",
"Terra Cotta": "POWERSELECTRIC-FRONT-A388_-_Terra_Cotta_-_Transparent.webp?v=1716499232",
"Mocha Frost Metallic": "Hero-Taylor-Powers-Electric-Mocha-Frost-Metallic.png?v=1771968821",
"Violin Burst": "Hero-Taylor-Powers-Electric-Violin-Burst.png?v=1771970652"
},
"Black": {
"Jet Black": "POWERSELECTRIC-FRONT-A141_-_Jet_Black_-_Transparent.webp?v=1715716484",
"Shadow Black": "POWERSELECTRIC-FRONT-05192023-A004-SHADOWBLACK-TRANSPARENT.webp?v=1705033409",
"Satin Black": "POWERSELECTRIC-FRONT-072523-A069-SATIN-BLACK-TRANSPARENT.webp?v=1705033409",
"Graphite Metallic": "Graphite_Metallic_-_Transparent.webp?v=1716498783"
},
"Yellow": {
"Signal Yellow": "POWERSELECTRIC-FRONT-05192023-A009-SIGNALYELLOW-TRANSPARENT.webp?v=1705032933",
"Saffron Yellow Metallic": "POWERSELECTRIC-FRONT-05192023-A012-SAFFRONYELLOWMETALIC-TRANSP_png.webp?v=1705032933",
"Buttercream Yellow": "POWERSELECTRIC-FRONT-A245_-_Buttercream_Yellow_-_Transparent.webp?v=1715721416",
"Summer Yellow": "POWERSELECTRIC-FRONT-A358_-_Summer_Yellow_-_Transparent.webp?v=1715721431",
"Pale Ale": "PowersElectric-Transparent-A500-PaleAle.webp?v=1719254418",
"Solana Sunset": "PowersElectric-Transparent-A577-SolanaSunset.webp?v=1719265346",
"Pastel Yellow": "PowersElectric-Transparent-PastelYello.png?v=1743031591",
"Fayence Yellow": "PowersElectric-Transparent-FayenceYell.png?v=1743033016"
},
"Purple": {
"Amethyst Pearl Metallic": "POWERSELECTRIC-FRONT-072523-A094-Amethyst-Pearl-Metallicc-TRANSPARENT.webp?v=1705036381",
"Aubergine": "PowersElectric-Transparent-A582-Aubergine.webp?v=1719252358",
"Frozen Berry Metallic": "PowersElectric-Transparent-A499-FrozenBerryMetallic.webp?v=1719252384",
"Viola Purple Metallic": "PowersElectric-Transparent-ViolaPurpleMetallic.png?v=1743030594",
"Ube Burst": "Hero-Taylor-Powers-Electric-Ube-Burst.png?v=1771969961",
"Velvet Purple Metallic": "Hero-Taylor-Powers-Electric-Velvet-Purple-Metallic.png?v=1771970265"
},
"Orange": {
"Cosmo Orange": "POWERSELECTRIC-FRONT-06022023-A020-COSMOORANGE-TRANSPARENT.webp?v=1705037111",
"Creamsicle": "POWERSELECTRIC-FRONT-05192023-A016-CREAMSICLE-TRANSPARENT_0ed6a014-d13e-43af-8668-4896f5497609.webp?v=1714164858",
"Desert Dawn": "PowersElectric-FRONT-071823-A061-DESERTDAWN-TRANSPARENT.webp?v=1714164858",
"Hemi Orange": "PowersElectric-FRONT-071823-A086-HEMI-ORANGE-TRANSPARENT.webp?v=1714164858",
"Sweet Tea Orange": "POWERSELECTRIC-FRONT-05192023-A015-SWEETTEAORANGE-TRANSPARENT.webp?v=1714164858",
"Orange": "POWERSELECTRIC-FRONT-A184_-_Orange_-_Transparent.webp?v=1715719965",
"Salmon Metallic": "POWERSELECTRIC-FRONT-A151_-_Salmon_Metallic_-_Transparent.webp?v=1715720053",
"Valencia Orange": "POWERSELECTRIC-FRONT-A228_-_Valencia_Orange_-_Transparent.webp?v=1715720074",
"Wild Honey Burst": "Powers_Electric-Transparent_-_A060_-_Wild_Honey_burst.webp?v=1716485416",
"Copper Metallic": "PowersElectric-Transparent-A467-CopperMetallic.webp?v=1719251687",
"Continental Orange": "Hero-Close-Taylor-Powers-Electric-Continental-Orange.png?v=1771968065",
"Thin Finish, Sweet Tea Orange": "Hero-Taylor-Powers-Electric-Sweet-Tea-Orange-Thin-Finish.png?v=1771972126"
},
"White": {
"Pearl White": "POWERSELECTRIC-FRONT-061423-A048-PEARLWHITE-0363.webp?v=1705037307",
"Moonlight White": "POWERSELECTRIC-FRONT-072523-A101-Moonlight-White-TRANSPARENT_04aef897-1a85-4979-8f85-45b9b9487e96.webp?v=1705037307",
"Pastel Beige": "POWERSELECTRIC-FRONT-A398_-_Pastel_Beige_-_Transparent.webp?v=1716487470"
},
"Pink": {
"Cochon Pink": "PowersElectric-Transparent-A568-Cochon_Pink.webp?v=1719253023",
"Magenta": "PowersElectric-Transparent-A437-Magenta.webp?v=1719253248",
"Ruby Star": "POWERSELECTRIC-FRONT-A207_-_Ruby_Star_-_Transparent.webp?v=1716498635",
"California Coral": "PowersElectric-Transparent-CaliforniaC.png?v=1743025443"
},
"Gold": {
"Byzantine Gold": "POWERSELECTRIC-FRONT-A145_-_Byzantine_Gold_-_Transparent.webp?v=1716499128",
"Casablanca Beige Metallic": "POWERSELECTRIC-FRONT-A392_-_Casablanca_Beige_-_Transparent.webp?v=1716499287",
"Nordic Gold Metallic": "POWERSELECTRIC-FRONT-A410_-_Nordic_Gold_Metallic_-_Transparent.webp?v=1716499434",
"Platinum Metallic": "POWERSELECTRIC-FRONT-A415_-_Platinum_Metallic_-_Transparent.webp?v=1716499442",
"Golden Metallic": "PowersElectric-Transparent-A446-GoldenMetallic.webp?v=1719253796",
"Golden Yellow Metallic": "PowersElectric-Transparent-A578-GoldenYellowMetallic.webp?v=1719253812"
},
"Silver and Gray": {
"London Grey": "PowersElectric-FRONT--080123-A107-LondonGray-8357_f417ddfc-f291-4125-ab0c-84ba6970dee2.webp?v=1705033409",
"Battleship Gray": "POWERSELECTRIC-FRONT-A235_-_Battleship_Grey_-_Transparent.webp?v=1715716677",
"Polar Silver Metallic": "POWERSELECTRIC-FRONT-A421_-_Polar_Silver_Metallic_-_Transparent.webp?v=1716487484",
"Chalk": "POWERSELECTRIC-FRONT-A258_-_Chalk_-_Transparent.webp?v=1716487453",
"Dolomite Silver": "POWERSELECTRIC-FRONT-062823-A056-DOLOMITE-TRANSPARENT.png?v=1719265085",
"Liquid Metal Chrome Blue": "PowersElectric-Transparent-LiquidMetal.png?v=1743032193"
}
};

  var COLOR_IMAGES = {}, COLOR_GROUPS = {};
  Object.keys(COLOR_LIBRARY).forEach(function (fam) {
    Object.keys(COLOR_LIBRARY[fam]).forEach(function (name) {
      var k = name.toLowerCase().replace(/[^a-z0-9]/g, "");
      COLOR_IMAGES[k] = COLOR_LIBRARY[fam][name];
      COLOR_GROUPS[k] = fam;
    });
  });

  var FAMILIES = [
    { id: "atype",  label: "A-Type", blurb: "Non-figured top, solid colors, full gloss body" },
    { id: "select", label: "A-Type Select", blurb: "Flame maple top with a translucent color" }
  ];

  var TIERS = {
    atype: [
      o("Standard", "A solid color from the standard A-Type chart"),
      o("Premium", "One solid color from the premium chart"),
      o("Two-Tone, Color Shift or Custom Color",
        "Two premium colors, a Chroma color shift, or any solid color not on the premium chart")
    ],
    select: [
      o("Standard", "A finish from the standard Select chart"),
      o("Ghost Flame", "Transparent flame top with solid color back and sides"),
      o("Premium", "Gloss flame top with satin black back and sides"),
      o("Custom", "Any translucent stain or Ghost Flame not on the standard or premium charts")
    ]
  };

  function familyOf(color) {
    var hit = null;
    Object.keys(TWO_TONE_FAMILIES).forEach(function (f) {
      if (TWO_TONE_FAMILIES[f].indexOf(color) > -1) hit = f;
    });
    return hit;
  }
  function twoToneFirst() {
    var all = [];
    Object.keys(TWO_TONE_FAMILIES).forEach(function (f) { all = all.concat(TWO_TONE_FAMILIES[f]); });
    return list(all.sort());
  }
  function twoToneSecond() {
    var f = familyOf(state.ttA);
    if (!f) return [];
    return list(TWO_TONE_FAMILIES[f].filter(function (c) { return c !== state.ttA; }).sort());
  }

  function isA(s)   { return s.family === "atype"; }
  function isSel(s) { return s.family === "select"; }
  var TWO = "Two-Tone, Color Shift or Custom Color";

  /* Sections. Each has: id, label, step, type, and optional fam filter.
     type: radio | select | checks | text | textarea | contact
     rerender: redraw the step on change, for fields others depend on.
     swatch: show the options as photo cards instead of a dropdown. */
  var SECTIONS = [

    /* --- STEP 1: model ------------------------------------ */
    { id: "family", label: "Model", step: 1, type: "radio", required: true,
      options: FAMILIES.map(function (f) { return { label: f.label, value: f.id, blurb: f.blurb }; }),
      help: "Everything after this is filtered to fit what you pick here." },

    { id: "tier", label: "Finish level", step: 1, type: "radio", dynamic: "tiers",
      help: "This sets which color charts are open to you on the next step." },

    /* --- STEP 2: finish ----------------------------------- */
    { id: "stdColor", label: "Color", step: 2, type: "text",
      showIf: function (s) { return s.tier === "Standard"; },
      placeholder: "Name the color you have in mind",
      help: "We will confirm it against the current Powers Electric standard chart." },

    { id: "premColor", label: "Color", step: 2, type: "select", swatch: true,
      showIf: function (s) { return isA(s) && s.tier === "Premium"; },
      options: list(PREMIUM) },

    { id: "ttType", label: "Finish style", step: 2, type: "radio",
      showIf: function (s) { return isA(s) && s.tier === TWO; },
      options: [
        o("Two-tone", "Two colors from the premium chart"),
        o("Color shift", "A Chroma finish that changes color with the light"),
        o("Custom color", "Any single solid color not on the premium chart")
      ]},

    { id: "ttA", label: "Two-tone, first color", step: 2, type: "select", rerender: true, swatch: true,
      showIf: function (s) { return isA(s) && s.tier === TWO && s.ttType === "Two-tone"; },
      dynamic: "ttA",
      help: "Two-tone pairs have to share a base coat, so the second list only shows colors that work with your first choice." },

    { id: "ttB", label: "Two-tone, second color", step: 2, type: "select", swatch: true,
      showIf: function (s) { return isA(s) && s.tier === TWO && s.ttType === "Two-tone" && !!s.ttA; },
      dynamic: "ttB" },

    { id: "shift", label: "Color", step: 2, type: "select", swatch: true,
      showIf: function (s) { return isA(s) && s.tier === TWO && s.ttType === "Color shift"; },
      options: list(SHIFTS),
      help: "Some of these are working names and may change before they are finalized." },

    { id: "customColor", label: "Color", step: 2, type: "text",
      showIf: function (s) {
        return (isA(s) && s.tier === TWO && s.ttType === "Custom color") ||
          (isSel(s) && s.tier === "Custom");
      },
      placeholder: "A paint code, a car color, a photo you have seen, anything",
      help: "Name it however you like. We will take it to Powers Electric and confirm what is possible." },

    { id: "ghostColor", label: "Color", step: 2, type: "select", swatch: true,
      showIf: function (s) { return isSel(s) && s.tier === "Ghost Flame"; },
      options: list(GHOST) },

    { id: "selPremColor", label: "Color", step: 2, type: "select", swatch: true,
      showIf: function (s) { return isSel(s) && s.tier === "Premium"; },
      options: list(SELECT_PREMIUM) },

    { id: "aExtras", label: "Finish details", step: 2, type: "checks", fam: ["atype"],
      options: list(["Dark Honduran rosewood fingerboard", "Color matched headstock"]) },

    { id: "selExtras", label: "Top and finish", step: 2, type: "checks", fam: ["select"],
      options: list(["Quilted maple top", "Plain maple top", "Hand-picked top", "Hand-rubbed satin finish"]),
      help: "Top options depend on the wood Powers Electric has on hand when your guitar is built." },

    /* --- STEP 3: hardware --------------------------------- */
    { id: "pickups", label: "Pickups", step: 3, type: "radio", options: [
      o("FF42, full Faraday", "Warmer, with more clarity and fidelity"),
      o("PF42, partial Faraday", "Brighter and punchier")
    ]},

    { id: "tailpiece", label: "Tailpiece", step: 3, type: "radio", options: [
      o("CamTail vibrato", "Strings keep their pitch relationship to each other as you dip"),
      o("HardTail", "Fixed bridge, no vibrato")
    ]},

    /* --- STEP 4: details ---------------------------------- */
    { id: "timing", label: "When do you need it", step: 4, type: "select", options: list([
      "No deadline", "Within six months", "Within a year", "For a specific date, noted below"
    ]), help: "Powers Electric builds in small numbers and lead times vary." },

    { id: "notes", label: "Anything else", step: 4, type: "textarea",
      placeholder: "A guitar you have played, a finish you have seen, a spec you could not find above, questions for us." },

    /* --- STEP 5: contact ---------------------------------- */
    { id: "contact", label: "Your details", step: 5, type: "contact", required: true }
  ];

  var STEP_NAMES = ["Model", "Finish", "Hardware", "Details", "Send"];

  /* ---------------------------------------------------------
     3. STATE + RENDER
     --------------------------------------------------------- */
  var state = {};
  var step = 1;
  var MAXSTEP = STEP_NAMES.length;

  var root = document.getElementById("tmePE");
  var panels = document.getElementById("pePanels");
  var stepsNav = document.getElementById("peSteps");
  var summaryEl = document.getElementById("peSummary");
  var statusEl = document.getElementById("peStatus");

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* Photo lookup. Keys are the color name with everything but letters
     and digits stripped, so "London Grey" and "london grey" both hit. */
  function normKey(s) { return String(s).toLowerCase().replace(/[^a-z0-9]/g, ""); }

  /* Resolve a color name to a key in the photo library: an exact match,
     or a longer listed name that starts with it, which catches pairs
     like "Juniper Green" and Powers' "Juniper Green Quilted". Never the
     other way round, or "Cruise Night Blue Ghost Flame" would borrow the
     photo of plain Cruise Night Blue and show the wrong finish. */
  function libKey(name) {
    var n = normKey(name);
    if (COLOR_IMAGES[n]) return n;
    var hit = "";
    Object.keys(COLOR_IMAGES).forEach(function (k) {
      if (!hit && k.indexOf(n) === 0) hit = k;
    });
    return hit;
  }

  function imageFor(name) {
    var k = libKey(name);
    if (!k) return "";
    return CONFIG.imageBase + COLOR_IMAGES[k] + "&width=320";
  }

  function groupFor(name) { return COLOR_GROUPS[libKey(name)] || "More colors"; }

  function optionsFor(sec) {
    if (sec.dynamic === "tiers") return TIERS[state.family] || [];
    if (sec.dynamic === "ttA") return twoToneFirst();
    if (sec.dynamic === "ttB") return twoToneSecond();
    return (sec.options || []).slice();
  }

  function visible(sec) {
    if (sec.fam && sec.fam.indexOf(state.family) === -1) return false;
    if (sec.showIf && !sec.showIf(state)) return false;
    if (sec.id === "tier" && !state.family) return false;
    if (sec.step > 1 && !state.family) return false;
    return true;
  }

  /* Drop answers that no longer apply: hidden fields, and picks that
     are not in the current option list (a second two-tone color from
     another base coat, say). Keeps the spec sheet honest. */
  function prune() {
    var changed = true;
    while (changed) {
      changed = false;
      SECTIONS.forEach(function (sec) {
        if (sec.type === "contact" || state[sec.id] === undefined) return;
        if (!visible(sec)) { delete state[sec.id]; delete state[sec.id + "_typed"]; changed = true; return; }
        if (sec.type === "radio" || sec.type === "select") {
          var ok = optionsFor(sec).some(function (x) { return (x.value || x.label) === state[sec.id]; });
          if (!ok) { delete state[sec.id]; changed = true; }
        }
        if (sec.type === "checks") {
          var labels = optionsFor(sec).map(function (x) { return x.label; });
          var kept = state[sec.id].filter(function (x) { return labels.indexOf(x) > -1; });
          if (kept.length !== state[sec.id].length) { state[sec.id] = kept; changed = true; }
        }
      });
    }
  }

  function render() {
    prune();
    var html = "";
    SECTIONS.forEach(function (sec) {
      if (sec.step !== step || !visible(sec)) return;
      html += '<fieldset class="tme-cs__field" data-id="' + sec.id + '">';
      html += '<legend class="tme-cs__legend">' + esc(sec.label) +
        (sec.required ? ' <span class="tme-cs__req">required</span>' : "") + "</legend>";
      if (sec.help) html += '<p class="tme-cs__help">' + esc(sec.help) + "</p>";
      html += renderControl(sec);
      html += "</fieldset>";
    });
    if (!html) html = '<p class="tme-cs__help">Pick a model and finish level on step one first.</p>';
    panels.innerHTML = html;
    bind();
    paintSteps();
    paintSummary();
    document.getElementById("pePrev").disabled = step === 1;
    document.getElementById("peNext").hidden = step === MAXSTEP;
    document.getElementById("peSend").hidden = step !== MAXSTEP;
  }

  function renderControl(sec) {
    var opts = optionsFor(sec);
    var v = state[sec.id];
    var h = "";

    if (sec.type === "radio") {
      h += '<div class="tme-cs__cards">';
      opts.forEach(function (opt) {
        var val = opt.value || opt.label;
        h += '<label class="tme-cs__card' + (v === val ? " is-on" : "") + '">' +
          '<input type="radio" name="' + sec.id + '" value="' + esc(val) + '"' +
          (v === val ? " checked" : "") + '>' +
          '<span class="tme-cs__card-t">' + esc(opt.label) + "</span>" +
          (opt.blurb ? '<span class="tme-cs__card-b">' + esc(opt.blurb) + "</span>" : "") +
          "</label>";
      });
      h += "</div>";

    } else if (sec.type === "select" && sec.swatch) {
      h += renderSwatches(sec, opts, v);

    } else if (sec.type === "select") {
      h += '<select class="tme-cs__select" name="' + sec.id + '">';
      h += '<option value="">' + ASK + "</option>";
      opts.forEach(function (opt) {
        var val = opt.value || opt.label;
        h += '<option value="' + esc(val) + '"' + (v === val ? " selected" : "") + ">" + esc(opt.label) + "</option>";
      });
      h += "</select>";

    } else if (sec.type === "checks") {
      var arr = v || [];
      h += '<div class="tme-cs__checks">';
      opts.forEach(function (opt) {
        var on = arr.indexOf(opt.label) > -1;
        h += '<label class="tme-cs__check' + (on ? " is-on" : "") + '">' +
          '<input type="checkbox" name="' + sec.id + '" value="' + esc(opt.label) + '"' +
          (on ? " checked" : "") + '><span>' + esc(opt.label) + "</span></label>";
      });
      h += "</div>";

    } else if (sec.type === "text") {
      h += '<input class="tme-cs__input" type="text" name="' + sec.id + '" value="' +
        esc(v || "") + '" placeholder="' + esc(sec.placeholder || "") + '">';

    } else if (sec.type === "textarea") {
      h += '<textarea class="tme-cs__input tme-cs__textarea" name="' + sec.id +
        '" rows="5" placeholder="' + esc(sec.placeholder || "") + '">' + esc(v || "") + "</textarea>";

    } else if (sec.type === "contact") {
      var c = state.contact || {};
      h += '<div class="tme-cs__grid">' +
        inp("name", "Name", c.name, "text", true) +
        inp("email", "Email", c.email, "email", true) +
        inp("phone", "Phone", c.phone, "tel") +
        inp("city", "City and state", c.city, "text") +
      "</div>";
      h += '<label class="tme-cs__check' + (c.optin ? " is-on" : "") +
        '" style="margin-top:14px"><input type="checkbox" data-c="optin"' +
        (c.optin ? " checked" : "") + '><span>Send me occasional news about ' + CONFIG.brand +
        ' arrivals at the shop</span></label>';
    }
    return h;
  }

  /* Photo grid. Same data as the dropdown it replaces, so the spec
     sheet, the email and the Klaviyo payload are unchanged.
     Colors sit behind a row of family tabs, so the customer sees one
     family at a time instead of scrolling the whole chart. */
  var ALL = "*";

  function renderSwatches(sec, opts, v) {
    // On the long charts, show only the colors we have a photo of.
    // The rest are still orderable: the box above takes anything typed.
    if (opts.length > 12) {
      opts = opts.filter(function (opt) { return !!imageFor(opt.label) || (opt.value || opt.label) === v; });
    }
    var groups = {}, order = [];
    opts.forEach(function (opt) {
      var g = groupFor(opt.label);
      if (!groups[g]) { groups[g] = []; order.push(g); }
      groups[g].push(opt);
    });
    order.sort(function (a, b) {
      if (a === "More colors") return 1;
      if (b === "More colors") return -1;
      return a.localeCompare(b);
    });

    // A short list does not need tabs: show the lot.
    var tabbed = opts.length > 12 && order.length > 1;
    // Open on the family the current pick belongs to, or on the
    // biggest one, so the first thing a customer sees is a full grid.
    var biggest = order.slice().sort(function (a, b) { return groups[b].length - groups[a].length; })[0];
    var active = tabbed ? (v ? groupFor(v) : biggest) : ALL;

    var typed = state[sec.id + "_typed"] || "";
    var h = '<p class="tme-cs__help pe-sw__hint">These are a sampling of what Powers Electric offers. ' +
      'Search below, or type a color you have in mind even if it is not shown. ' +
      'Leave it blank if you have no preference.</p>';
    h += '<input class="tme-cs__input pe-sw__filter" type="text" data-filter="' + sec.id +
      '" value="' + esc(typed) +
      '" placeholder="Search or name a color">';

    if (tabbed) {
      h += '<div class="pe-sw__tabs" data-tabs="' + sec.id + '" role="tablist">';
      order.forEach(function (g) {
        h += '<button type="button" class="pe-sw__tab' + (g === active ? " is-on" : "") +
          '" data-tab="' + esc(g) + '">' + esc(g) +
          ' <span class="pe-sw__count">' + groups[g].length + "</span></button>";
      });
      h += '<button type="button" class="pe-sw__tab pe-sw__tab--all" data-tab="' + ALL +
        '">All colors <span class="pe-sw__count">' + opts.length + "</span></button>";
      h += "</div>";
    }

    h += '<div class="pe-sw" data-grid="' + sec.id + '" data-active="' + esc(active) + '">';

    order.forEach(function (g) {
      groups[g].forEach(function (opt) {
        var val = opt.value || opt.label;
        var src = imageFor(opt.label);
        var show = !tabbed || g === active;
        h += '<label class="pe-sw__card' + (v === val ? " is-on" : "") +
          '" data-name="' + esc(opt.label.toLowerCase()) + '" data-group="' + esc(g) + '"' +
          (show ? "" : " hidden") + ">" +
          '<input type="radio" data-sw="1" name="' + sec.id + '" value="' + esc(val) + '"' +
          (v === val ? " checked" : "") + ">" +
          (src ? '<img class="pe-sw__img" loading="lazy" alt="' + esc(opt.label) +
            '" src="' + esc(src) + '">' : '<span class="pe-sw__noimg">No photo yet</span>') +
          '<span class="pe-sw__name">' + esc(opt.label) + "</span></label>";
      });
    });
    h += "</div>";
    return h;
  }

  /* One place decides what a grid shows. A search query beats the tabs
     and looks across every family; an empty box hands control back. */
  function applyFilter(id) {
    var grid = panels.querySelector('[data-grid="' + id + '"]');
    var box = panels.querySelector('[data-filter="' + id + '"]');
    if (!grid) return;
    var q = box ? box.value.trim().toLowerCase() : "";
    var active = grid.getAttribute("data-active") || ALL;
    var hits = 0;
    grid.querySelectorAll(".pe-sw__card").forEach(function (c) {
      var name = c.getAttribute("data-name") || "";
      var group = c.getAttribute("data-group");
      var match = name.indexOf(q) > -1;
      if (q && match) hits++;
      c.hidden = q ? !match : (active !== ALL && group !== active);
    });
    // Text that matches nothing we list is taken as the customer's own
    // answer, so a color off the chart still reaches us. Text that does
    // match is just a search, and waits for them to pick a card.
    if (q && !hits) state[id + "_typed"] = box.value.trim();
    else delete state[id + "_typed"];
    var tabs = panels.querySelector('[data-tabs="' + id + '"]');
    if (tabs) tabs.classList.toggle("is-muted", !!q);
  }

  function bindSwatches() {
    panels.querySelectorAll("input[data-sw]").forEach(function (el) {
      el.addEventListener("change", function () {
        if (el.value) state[el.name] = el.value; else delete state[el.name];
        delete state[el.name + "_typed"];
        var box = panels.querySelector('[data-filter="' + el.name + '"]');
        if (box) box.value = "";
        var sec = secById(el.name);
        if (sec && sec.rerender) { render(); return; }
        applyFilter(el.name);
        var grid = panels.querySelector('[data-grid="' + el.name + '"]');
        if (grid) {
          grid.querySelectorAll(".pe-sw__card").forEach(function (c) { c.classList.remove("is-on"); });
          el.closest(".pe-sw__card").classList.add("is-on");
        }
        paintSummary();
      });
    });
    panels.querySelectorAll("[data-filter]").forEach(function (box) {
      box.addEventListener("input", function () {
        applyFilter(box.getAttribute("data-filter"));
        paintSummary();
      });
    });
    // Restore the view when a step is redrawn with a search still in it.
    panels.querySelectorAll("[data-filter]").forEach(function (box) {
      if (box.value.trim()) applyFilter(box.getAttribute("data-filter"));
    });
    panels.querySelectorAll("[data-tabs]").forEach(function (tabs) {
      var id = tabs.getAttribute("data-tabs");
      tabs.querySelectorAll(".pe-sw__tab").forEach(function (t) {
        t.addEventListener("click", function () {
          var grid = panels.querySelector('[data-grid="' + id + '"]');
          if (!grid) return;
          var box = panels.querySelector('[data-filter="' + id + '"]');
          if (box) box.value = "";
          grid.setAttribute("data-active", t.getAttribute("data-tab"));
          tabs.querySelectorAll(".pe-sw__tab").forEach(function (x) { x.classList.remove("is-on"); });
          t.classList.add("is-on");
          applyFilter(id);
          paintSummary();
          grid.scrollTop = 0;
        });
      });
    });
  }

  function inp(k, label, val, type, req) {
    return '<label class="tme-cs__lab">' + label + (req ? ' <span class="tme-cs__req">required</span>' : "") +
      '<input class="tme-cs__input" type="' + type + '" data-c="' + k + '" value="' + esc(val || "") + '"></label>';
  }

  function secById(id) { return SECTIONS.filter(function (s) { return s.id === id; })[0]; }

  function bind() {
    panels.querySelectorAll('input[type=radio]:not([data-sw])').forEach(function (el) {
      el.addEventListener("change", function () {
        state[el.name] = el.value;
        render();
      });
    });
    panels.querySelectorAll('select[name]').forEach(function (el) {
      el.addEventListener("change", function () {
        state[el.name] = el.value;
        var sec = secById(el.name);
        if (sec && sec.rerender) render(); else paintSummary();
      });
    });
    panels.querySelectorAll('input[type=checkbox][name]').forEach(function (el) {
      el.addEventListener("change", function () {
        var arr = state[el.name] || [];
        var i = arr.indexOf(el.value);
        if (el.checked && i === -1) arr.push(el.value);
        if (!el.checked && i > -1) arr.splice(i, 1);
        state[el.name] = arr;
        el.closest(".tme-cs__check").classList.toggle("is-on", el.checked);
        paintSummary();
      });
    });
    panels.querySelectorAll('input[type=text][name], textarea[name]').forEach(function (el) {
      el.addEventListener("input", function () { state[el.name] = el.value; paintSummary(); });
    });
    bindSwatches();
    panels.querySelectorAll('[data-c]').forEach(function (el) {
      el.addEventListener(el.type === "checkbox" ? "change" : "input", function () {
        state.contact = state.contact || {};
        state.contact[el.getAttribute("data-c")] = el.type === "checkbox" ? el.checked : el.value;
        if (el.type === "checkbox") el.closest(".tme-cs__check").classList.toggle("is-on", el.checked);
      });
    });
  }

  function paintSteps() {
    var h = "";
    for (var i = 1; i <= MAXSTEP; i++) {
      h += '<button type="button" class="tme-cs__step' + (i === step ? " is-on" : "") +
        (i < step ? " is-done" : "") + '" data-step="' + i + '"' +
        (i > 1 && !state.family ? " disabled" : "") + '>' +
        '<span class="tme-cs__step-n">' + i + "</span>" + STEP_NAMES[i - 1] + "</button>";
    }
    stepsNav.innerHTML = h;
    stepsNav.querySelectorAll("button").forEach(function (b) {
      b.addEventListener("click", function () {
        step = parseInt(b.getAttribute("data-step"), 10); render(); scrollTop();
      });
    });
  }

  function familyLabel() {
    var f = FAMILIES.filter(function (x) { return x.id === state.family; })[0];
    return f ? f.label : "";
  }

  /* Build the human-readable spec. Used for the sidebar, the
     clipboard copy, and the email body. One source of truth. */
  function specLines() {
    var out = [];
    SECTIONS.forEach(function (sec) {
      if (sec.type === "contact" || !visible(sec)) return;
      var v = state[sec.id];
      var note = sec.swatch ? state[sec.id + "_typed"] : "";
      if (!v && note) { out.push([sec.label, note]); return; }
      if (!v || (Array.isArray(v) && !v.length)) return;
      // A pick plus something typed: keep both rather than guess.
      if (note) { out.push([sec.label, v]); out.push([sec.label + " note", note]); return; }
      if (sec.id === "family") { out.push([sec.label, familyLabel()]); return; }
      out.push([sec.label, Array.isArray(v) ? v.join(", ") : v]);
    });
    return out;
  }

  function paintSummary() {
    var lines = specLines();
    if (!lines.length) {
      summaryEl.innerHTML = '<p class="tme-cs__sheet-empty">Choose a model to start the sheet.</p>';
      return;
    }
    summaryEl.innerHTML = lines.map(function (l) {
      return '<div class="tme-cs__row"><span class="tme-cs__row-k">' + esc(l[0]) +
        '</span><span class="tme-cs__row-v">' + esc(l[1]) + "</span></div>";
    }).join("");
  }

  /* Klaviyo lists each property as its own row and its email templates
     cannot render newlines, so every spec field goes as a discrete
     property, plus spec_lines and spec_rows arrays for alert emails.
     Same shape as the Custom Shop form so one template can serve both. */
  function klaviyoProps() {
    var c = state.contact || {};
    var props = {
      form: CONFIG.formName, brand: CONFIG.brand,
      name: c.name || "", email: c.email || "", phone: c.phone || "",
      location: c.city || "", optin: !!c.optin
    };
    var lines = [], rows = [];
    specLines().forEach(function (l) {
      props[l[0]] = l[1];
      lines.push(l[0] + ": " + l[1]);
      rows.push({ label: l[0], value: l[1] });
    });
    props.spec_lines = lines;
    props.spec_rows = rows;
    return props;
  }

  function specText() {
    var lines = specLines();
    var c = state.contact || {};
    var t = CONFIG.brand.toUpperCase() + " BUILD REQUEST\n";
    t += "Received " + new Date().toLocaleString() + "\n\n";
    t += "CUSTOMER\n";
    t += "Name: " + (c.name || "") + "\nEmail: " + (c.email || "") +
      "\nPhone: " + (c.phone || "") + "\nLocation: " + (c.city || "") +
      "\nMarketing opt-in: " + (c.optin ? "yes" : "no") + "\n\nSPEC\n";
    lines.forEach(function (l) { t += l[0] + ": " + l[1] + "\n"; });
    t += "\nUnlisted fields were left open for discussion.\n";
    return t;
  }

  function scrollTop() {
    root.scrollIntoView({ behavior: prefersReduced() ? "auto" : "smooth", block: "start" });
  }
  function prefersReduced() {
    return window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function validate() {
    var c = state.contact || {};
    if (!state.family) return "Pick a model on step one first.";
    if (!state.tier) return "Choose a finish level on step one.";
    if (!c.name) return "Add your name so we know who to reply to.";
    if (!c.email || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(c.email)) return "Add a valid email address.";
    return null;
  }

  document.getElementById("peNext").addEventListener("click", function () {
    if (step === 1 && !state.family) { statusEl.textContent = "Pick a model to continue."; return; }
    statusEl.textContent = "";
    if (step < MAXSTEP) { step++; render(); scrollTop(); }
  });
  document.getElementById("pePrev").addEventListener("click", function () {
    if (step > 1) { step--; render(); scrollTop(); }
  });
  document.getElementById("peCopy").addEventListener("click", function () {
    navigator.clipboard.writeText(specText()).then(function () {
      var b = document.getElementById("peCopy");
      b.textContent = "Copied"; setTimeout(function () { b.textContent = "Copy spec to clipboard"; }, 1800);
    });
  });

  document.getElementById("peSend").addEventListener("click", function () {
    var err = validate();
    if (err) { statusEl.textContent = err; statusEl.className = "tme-cs__status is-err"; return; }
    if (root.querySelector('[name=company_website]').value) return; // bot

    var c = state.contact || {};
    var payload = {
      form: CONFIG.formName, brand: CONFIG.brand,
      name: c.name, email: c.email, phone: c.phone || "", location: c.city || "",
      optin: !!c.optin,
      instrument: familyLabel(), model: state.tier,
      spec: specText(),
      spec_json: JSON.stringify({ state: state })
    };

    var btn = this;
    btn.disabled = true;
    statusEl.className = "tme-cs__status";
    statusEl.textContent = "Sending your spec.";

    if (!CONFIG.endpoint) {
      window.location.href = "mailto:" + CONFIG.email +
        "?subject=" + encodeURIComponent(CONFIG.brand + " build request from " + (c.name || "a customer")) +
        "&body=" + encodeURIComponent(specText());
      statusEl.textContent = "Your email client should be opening. If it does not, copy the spec and send it to " + CONFIG.email + ".";
      btn.disabled = false;
      return;
    }

    // Klaviyo's client events endpoint needs a JSON:API envelope and a
    // revision header. Anything else gets the flat payload above.
    var isKlaviyo = CONFIG.endpoint.indexOf("klaviyo.com/client/events") > -1;
    var headers = { "Content-Type": "application/json" };
    var body = payload;

    if (isKlaviyo) {
      // Pin this to whatever revision is current in Klaviyo's reference.
      headers.revision = "2026-07-15";
      var nameBits = (c.name || "").trim().split(/\s+/);
      var profile = { email: c.email };
      if (nameBits[0]) profile.first_name = nameBits[0];
      if (nameBits.length > 1) profile.last_name = nameBits.slice(1).join(" ");
      // Phone stays out of the profile: Klaviyo requires E.164 and will
      // reject the whole request on a badly formatted number. It is still
      // in the event properties below.
      body = {
        data: {
          type: "event",
          attributes: {
            metric: { data: { type: "metric", attributes: { name: CONFIG.formName } } },
            profile: { data: { type: "profile", attributes: profile } },
            properties: klaviyoProps()
          }
        }
      };
    } else {
      headers.Accept = "application/json";
    }

    fetch(CONFIG.endpoint, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(body)
    }).then(function (r) {
      if (!r.ok) {
        return r.text().then(function (t) {
          throw new Error("HTTP " + r.status + " " + r.statusText + " :: " + (t || "(empty response body)"));
        });
      }
      root.querySelector(".tme-cs__body").innerHTML =
        '<div class="tme-cs__done"><h2>Your spec is with us.</h2>' +
        "<p>We will read through it and get back to you at " +
        esc(c.email) + " with pricing, lead time and any questions about the parts you left " +
        "open. Thanks for thinking of us for this one.</p></div>";
      root.querySelector(".tme-cs__steps").hidden = true;
      scrollTop();
    }).catch(function (err) {
      console.group("[" + CONFIG.brand + " form] submission failed");
      console.error("Reason:", (err && err.message) ? err.message : err);
      console.error("Endpoint:", CONFIG.endpoint || "(not set)");
      console.error("Klaviyo mode:", isKlaviyo);
      console.error("Request headers:", headers);
      console.error("Request body:", body);
      console.error("A TypeError with no status usually means the request never "
        + "reached the server: a wrong or unreachable URL, or a CORS rejection.");
      console.groupEnd();
      statusEl.className = "tme-cs__status is-err";
      statusEl.textContent = "That did not send. Use the copy button to grab your spec and email it to " + CONFIG.email + " and we will pick it up from there.";
      btn.disabled = false;
    });
  });

  render();
})();